import request from '@/utils/request'
// 属性分类列表
export function fetchAttributeClassifyList (params) {
  return request({
    url: '/productAttribute/category/list',
    method: 'post',
    params: params
  })
}
// 添加属性分类
export function createAttributeClassify (data) {
  return request({
    url: '/productAttribute/category/create',
    method: 'post',
    params: data
  })
}
// 获取属性分类
export function getAttributeClassify (id) {
  return request({
    url: '/productAttribute/category/' + id,
    method: 'get',
  })
}
// 修改属性分类
export function updateAttributeClassify (id, data) {
  return request({
    url: '/productAttribute/category/update/' + id,
    method: 'post',
    data: data
  })
}
// 删除属性分类
export function deleteAttributeClassify (id) {
  return request({
    url: '/productAttribute/category/delete/' + id,
    method: 'get',
  })
}



// WEBPACK FOOTER //
// ./src/api/attributeClassify.js